import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'experience-schedules-curriculum-schedules-view-part',
	standalone: true,
	templateUrl: './curriculum-schedules-view.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./curriculum-schedules-view.part.scss'],
})
export class ExperienceSchedulingCurriculumSchedulesViewPart {
}